KXL.module('Components.ContentPane', function(ContentPane, KXL, Backbone, Marionette, $, _) {
	ContentPane.Controller = {
		getContentPane: function(options) {
			return new ContentPane.View(options);
		}
	};
});
